<template>
  <div class="content">
       <div class="menumodular">
        <ul>
          <li v-for="(item,index) in list" :key="index" @mouseenter="enter2(item)" @mouseleave="leave2(item)">
            <div class="Outerlayer">
              <div class="li-right">
                <i :class=item.Icon></i>
              </div>
              <div class="li-left" >
                <div class="left-title">{{item.title}}</div>
                <div class="left-Remarks">{{item.title2}}</div>
              </div>
            </div>
            <transition name="el-zoom-in-bottom">
              <div v-show="item.show" class="transition-box">
                <div class="li-right">
                  <i :class=item.Icon></i>
                </div> 
                <div class="see" @click="todesign(item.route)">点击查看更多</div>
              </div>
            </transition>
          </li>
        </ul>
      </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      list:[
        {Icon:'iconfont icon-sheji',title:'专属设计',title2:'量身定制 独具匠心',show:false,route:'/Designer'},
        {Icon:'iconfont icon-youqishua',title:'匠心施工',title2:'环保精工匠心工艺',show:false,route:'/DecorationProcess'},
        {Icon:'iconfont icon-security',title:'品牌主材',title2:'海量一线国际品牌主材',show:false,route:'/Product'},
        {Icon:'iconfont icon-RectangleCopy',title:'商务合作',title2:'共享亿万市场',show:false,route:'/NewJoin'},
      ]
    };
  },
  methods: {
    todesign(item) {
      this.$router.push({ path: item });
    },
    enter2(item){
      item.show = true
    },
    leave2(item){
      item.show = false
    }
  }
};
</script>
<style scoped>
.menumodular {
  width: 1280px;
  height: 260px;
  margin: 0 auto;
  margin-top: 79px;
}
.menumodular > ul {
  width: 90%;
  height: 260px;
  margin: 0 auto;
  padding-inline-start: 0px;
}
.menumodular > ul li {
  width: 24%;
  height: 242px;
  float: left;
  list-style: none;
  background: #fff;
  border: 1px solid #ccc;
  position: relative;
}
.menumodular > ul li:nth-child(1) {
  margin-left: 0;
}
.Outerlayer {
  width: 100%;
}
.li-left {
}
.li-right {
  width: 60px;
  height: 60px;
  background-color: #ffffff;
  border: solid 1px #cccccc;
  border-radius: 30px;
  margin: 0 auto;
  margin-top: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left-title {
  font-size: 20px;
  color: #000;
  margin-top: 20px;
}
.left-Remarks {
  text-align: center;
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
}
.iconfont {
  font-size: 40px;
  color: #b31d25;
}
.transition-box {
  width: 100%;
  height: 100%;
  background-color: #bc001d;
  text-align: center;
  color: #fff;
  box-sizing: border-box;
  position: absolute;
  top: 0;
}
.see{
  text-align: center;
  font-size: 18px;
  margin-top: 30px;
  cursor:pointer;
}
</style>
